import { render, staticRenderFns } from "./HotelImage.vue?vue&type=template&id=44842df9&scoped=true"
import script from "./HotelImage.vue?vue&type=script&lang=js"
export * from "./HotelImage.vue?vue&type=script&lang=js"
import style0 from "./HotelImage.vue?vue&type=style&index=0&id=44842df9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44842df9",
  null
  
)

export default component.exports